export const createSaveCustomCTAsRequest = (title, content) => {
	return {
		url: "/custom_ctas",
		method: "POST",
		data: {
			title,
			content,
		},
	};
};

export const createGetCustomCTAsListRequest = () => {
	return {
		url: "/custom_ctas",
		method: "GET",
	};
};

export const createUpdateCustomCTAsRequest = (id, title, content) => {
	return {
		url: `custom_ctas/${id}`,
		method: "PUT",
		data: {
			title,
			content,
		},
	};
};

export const createShowCustomCTAsRequest = (id) => {
	return {
		url: `custom_ctas/${id}`,
		method: "GET",
	};
};

export const createDeleteCustomCTAsRequest = (id) => {
	return {
		url: `custom_ctas/${id}`,
		method: "DELETE",
	};
};
